<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M8.678 9.87c-1.02.21-1.628.87-1.628 1.808 0 1.004.833 1.814 1.868 1.814A2.782 2.782 0 0 0 11.7 10.71a7.89 7.89 0 0 0-.345-2.34c-.593.803-1.65 1.29-2.678 1.5ZM10.125.503s.555 1.987.555 3.6c0 1.545-1.012 2.797-2.557 2.797C6.57 6.9 5.4 5.647 5.4 4.102l.022-.27A10.326 10.326 0 0 0 3 10.5c0 3.315 2.685 6 6 6s6-2.685 6-6c0-4.043-1.943-7.65-4.875-9.997ZM9 15a4.504 4.504 0 0 1-4.5-4.5c0-1.148.225-2.28.645-3.322A4.187 4.187 0 0 0 8.123 8.4c1.995 0 3.562-1.373 3.96-3.323A11.078 11.078 0 0 1 13.5 10.5c0 2.482-2.018 4.5-4.5 4.5Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
